import React from 'react';
import AddTransferInvoiceDialog from '../components/invoices/AddTransferInvoiceDialog';

const InvoiceFormPage: React.FC = () => {
  const handleClose = () => {
    if (window.opener) {
      window.close();
    } else {
      window.location.href = '/accounting/purchases';
    }
  };

  const handleSave = () => {
    // Po zapisaniu odśwież listę faktur w oknie nadrzędnym i zamknij
    try {
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage({ type: 'invoice:created' }, '*');
      }
    } catch {}
    handleClose();
  };

  return (
    <AddTransferInvoiceDialog
      open={true}
      onClose={handleClose}
      onSave={handleSave}
    />
  );
};

export default InvoiceFormPage;
